import { withRouter } from 'react-router-dom';
import React from 'react';

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (this.props.scrollTo !== undefined && this.props.scrollTo !== false) {
        window.scrollTo(this.props.scrollTo[0], this.props.scrollTo[1]);
      } else if (this.props.scrollTo === false) {
        return;
      } else {
        window.scrollTo(0, 0)
      }
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/common/scrollToTop/ScrollToTop.js